module.exports = __webpack_public_path__ + "static/img/190405-baby-twins.49460b4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gensunicerse/190405-baby-twins.jpg
// module id = VdWM
// module chunks = 0